import {
  type BubbleOnboardingResponseDto,
  onboardingGetBubbleQuery,
  useOnboardingSetDpaStatus,
  useOnboardingSetOnboardingStatus,
} from "@crowdcoursing/api/openapi";
import { useQueryClient } from "@tanstack/react-query";

import { useToast } from "~hooks/useToast";

import { readOnboardingError } from "./onboardingMembers";

export function useOnboardingMutations(bubbleId: string, parentBubbleId?: string) {
  const queryClient = useQueryClient();
  const toast = useToast();

  const refresh = (data: BubbleOnboardingResponseDto) => {
    const id = data.bubbleId ?? bubbleId;
    queryClient.setQueryData(onboardingGetBubbleQuery({ pathParams: { bubbleId: id } }).queryKey, data);
    void queryClient.invalidateQueries({ queryKey: ["api", "v1", "onboarding"] });
    if (parentBubbleId && parentBubbleId !== id) {
      void queryClient.invalidateQueries({
        queryKey: onboardingGetBubbleQuery({ pathParams: { bubbleId: parentBubbleId } }).queryKey,
      });
    }
  };

  const onError = (error: unknown) => {
    toast.error(readOnboardingError(error));
    void queryClient.invalidateQueries({
      queryKey: onboardingGetBubbleQuery({ pathParams: { bubbleId } }).queryKey,
    });
  };

  return {
    setDpa: useOnboardingSetDpaStatus({ onError, onSuccess: refresh }),
    setStatus: useOnboardingSetOnboardingStatus({ onError, onSuccess: refresh }),
  };
}
